/*
// @ts-nocheck
@ts-ignore
 */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import moment from "moment-timezone";
import styled, { css } from "styled-components";

import Input from "../ui-kit/input";
import { Button, Dropdown, Frame, RowWrapper } from "../ui-kit/styled-templates";
import Calendar from "./calendar";

const months = (t: any) => [
    t("mh9o8i59to8"),
    t("g39xa2hkqtw"),
    t("qzwababg9b"),
    t("xpc1zqnc9ue"),
    t("62eijj7rzkb"),
    t("wotw8p4258"),
    t("6xktls24v83"),
    t("oa9tn352av"),
    t("v6szhib84p9"),
    t("3n3qbi9jkym"),
    t("cuf6gjg9aj"),
    t("ndhtm62dmi"),
];

export interface DateRangePickerProps {
    onChange: Function;
    value: any;
    toggleComponent?: any;
    withTime?: boolean;
    saveOnSelect?: boolean;
    allowed?: {
        from?: number;
        to?: number;
    };
    placeholder?: string;
    disabled?: boolean;
}

const DateRangePicker = (props: DateRangePickerProps) => {
    const { t } = useTranslation();
    const { onChange, value, toggleComponent: ToggleComponent, withTime = true, saveOnSelect = false, disabled = false, allowed = {} } = props;

    console.log('DateRangePicker: render: props = ', props);
    console.log('DateRangePicker: render: disabled = ', disabled);

    const [monthStart, setMonthStart] = useState(moment().startOf("month"));
    const [selectFrom, setSelectFrom] = useState(null);
    const [selectTo, setSelectTo] = useState(null);
    const [timeFrom, setTimeFrom] = useState(`00:00`);
    const [timeTo, setTimeTo] = useState(`00:00`);
    const handlers = {
        prevMonth: () => {
            setMonthStart(monthStart.clone().subtract(1, "month"));
        },
        nextMonth: () => {
            setMonthStart(monthStart.clone().add(1, "month"));
        },
        dateClick: (date) => {
            if (!selectFrom) {
                setSelectFrom(date);
            } else if (!selectTo && date > selectFrom) {
                setSelectTo(date);
            } else {
                setSelectFrom(date);
                setSelectTo(null);
            }
        },
        cancelClick: () => {
            setSelectFrom(null);
            setSelectTo(null);
            setTimeFrom(`00:00`);
            setTimeTo(`00:00`);
        },
        saveClick: () => {
            onChange({
                target: {
                    value: {
                        from: +selectFrom.clone().set({ hour: timeFrom.split(":")[0], minute: timeFrom.split(":")[1] }),
                        to: +selectTo.clone().set({ hour: timeTo.split(":")[0], minute: timeTo.split(":")[1] }),
                    },
                },
            });
        },
    };
    useEffect(() => {
        const { from, to } = value;
        if (from) {
            setSelectFrom(moment(from));
            setTimeFrom(moment(from).format("HH:mm"));
        }
        if (to) {
            setSelectTo(moment(to));
            setTimeTo(moment(to).format("HH:mm"));
        }
    }, [value]);

    useEffect(() => {
        if (!!selectFrom && !!selectTo && selectTo > selectFrom && !!saveOnSelect) {
            handlers.saveClick();
        }
    }, [selectFrom, selectTo]);

    return (
        <Dropdown
            callable={!disabled}
            closeOnChildrenClick={false}
            toggle={ToggleComponent ? () => <ToggleComponent {...{ value, onChange }} /> : () => <CalendarIcon />}
            toggleProps={{ extra: disabled ? `opacity: 0.5; input { cursor: no-drop; }` : `input { cursor: pointer; }` }}
            menuProps={{ extra: `padding: 0; left: 0; right: unset;` }}
            menu={() => (
                <Frame extra={({ theme }) => `background: ${theme.background.primary}; border-radius: 8px;`}>
                    <Frame extra={({ theme }) => `flex-direction: row; border-bottom: 1px solid ${theme.grey};`}>
                        <Frame extra={({ theme }) => `padding: 19px;`}>
                            <Frame extra={`width: 100%; flex-direction: row; justify-content: space-between;`}>
                                <Chevron direction="left" onClick={handlers.prevMonth} />
                                <Frame extra={`font-size: 13px; line-height: 18px;`}>{months(t)[monthStart.month()]} {` ${moment(monthStart).format('YYYY')}`}</Frame>
                                {/*<Frame extra={`width: 28px;`} />*/}
                                <Chevron direction="right" onClick={handlers.nextMonth} />
                            </Frame>
                            <Calendar
                                monthStart={monthStart}
                                onDateClick={handlers.dateClick}
                                selectedRange={[selectFrom, selectTo]}
                                showOnlyCurrentMonth={true}
                                allowed={allowed}
                            />
                        </Frame>

                        {/*<Frame extra={`padding: 19px;`}>*/}
                        {/*    <Frame extra={`width: 100%; flex-direction: row; justify-content: space-between;`}>*/}
                        {/*        <Frame extra={`width: 28px;`} />*/}
                        {/*        <Frame extra={`font-size: 13px; line-height: 18px;`}>{months[(monthStart.month() + 1) % 12]}</Frame>*/}
                        {/*        <Chevron direction="right" onClick={handlers.nextMonth} />*/}
                        {/*    </Frame>*/}
                        {/*    <Calendar*/}
                        {/*        monthStart={monthStart.clone().add(1, "month")}*/}
                        {/*        onDateClick={handlers.dateClick}*/}
                        {/*        selectedRange={[selectFrom, selectTo]}*/}
                        {/*        showOnlyCurrentMonth={true}*/}
                        {/*        allowed={allowed}*/}
                        {/*    />*/}
                        {/*</Frame>*/}

                    </Frame>
                    {withTime && (
                        <RowWrapper extra={`padding: 19px; box-sizing: border-box;`}>
                            <Frame extra={`flex-direction: row;`}>
                                <Input type="time" value={timeFrom} onChange={(e) => setTimeFrom(e.target.value)} />
                                <Input type="time" value={timeTo} onChange={(e) => setTimeTo(e.target.value)} />
                            </Frame>
                            <Frame extra={`flex-direction: row;`}>
                                <Button
                                    background="white"
                                    extra={({ theme }) =>
                                        `margin-right: 1em; min-width: unset; font-size: 12px; line-height: 16px; border: 1px solid ${theme.grey}; color: ${theme.grey}; box-shadow: none;`
                                    }
                                    onClick={handlers.cancelClick}
                                >
                                    {t("rqkqho6obg")}
                                </Button>
                                <Button
                                    disabled={!selectFrom || !selectTo}
                                    background="green"
                                    extra={`min-width: unset; font-size: 12px; line-height: 16px; box-shadow: none;`}
                                    onClick={handlers.saveClick}
                                >
                                    {t("xyllmg8fdt")}
                                </Button>
                            </Frame>
                        </RowWrapper>
                    )}
                </Frame>
            )}
        />
    );
};

const Chevron = styled(Frame)<{ direction: `left` | `right` }>`
    width: 28px;
    height: 28px;
    border-radius: 4px;
    /* border: 1px solid ${({ theme }) => theme.grey}; */
    box-sizing: border-box;

    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }

    &:after {
        content: "";
        width: 12px;
        height: 12px;
        background: url("${require(`../../assets/icons/arrow-right.svg`).default}") no-repeat center center / contain;
        ${({ direction }) =>
            direction === "left" &&
            css`
                transform: rotate(180deg);
            `}
    }
`;

const CalendarIcon = styled(Frame)`
    width: 16px;
    height: 16px;
    background: url("${require(`../../assets/icons/calendar.svg`).default}") no-repeat center center / contain;
`;

export default DateRangePicker;
